import {CreateObject} from "../class/createObject";
import _ from 'underscore';

export class Bug {
    constructor(scene, group) {
        this.scene = scene;
        this.groupBug = group;
        this.dbBug = scene.dbBug = {
            timeToNew: null,
            items: []
        };
        this.scene.physics.add.collider(this.groupBug, this.groupBug)
        this.object = new CreateObject(this.dbBug, scene, group, 'bug')
    }

    generateBug() {
        this.object.generate();
    }

    pickUp(id, value) {
        let index = _.findIndex(this.dbBug.items, (element, index) => {
            return element.id === id;
        });
        if (index >= 0) {
            this.scene.projectLine -= value;
            if (this.scene.projectLine < 0) {
                this.scene.projectLine = 0;
            }
            this.scene.modelBar.updateProgress(this.scene.projectLine);
            this.dbBug.items.splice(index, 1)
        }
    }
}
